// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qiitC","fullView":"styles_fullView__3X6yE"};